import { useState } from 'react';
import ResponseException from '../models/ResponseException';
import { AxiosPrivate } from '../utils/axios';

export const useDeleteResponses = () => {
  const [errors, setErrors] = useState<string[]>([]);

  const deleteResponses = async (responsesToDelete: string[]) => {
    setErrors([]);
    try {
      const data = { id: responsesToDelete };
      await AxiosPrivate.delete('/responses/batch', { data });
    } catch (e) {
      setErrors(new ResponseException(e).getErrorMessage());
    }
  };

  return {
    deleteResponses,
  };
};
